
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import {
  getProductAccountList,
  newProductAccount
} from '@/api/product/productAccount'
import { accountGroupRules } from '@/utils/rules'
import { Form as ElForm } from 'element-ui'
import { addAccountGroup } from '@/api/product/accountGroup'
import { delObjEmptyKey } from '@/utils'
import { getType } from '@/utils/cookies'
@Component({
  name: 'addAccountGroup',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) product!: any

  private infoForm: any = {
    product_account: [],
    name: '',
    product: null,
    status: null,
    weight: [
      {
        id: '',
        weight: ''
      }
    ]
  }

  private status: any = null
  private isLoad: boolean = true
  private page: number = 1
  private page_size: number = 50
  private productList: any[] = []
  private productAccountList: any[] = []
  private loading = false
  private rules = accountGroupRules

  private currentSelection: any = []
  private reqArr: any = []
  // 获取产品账户数组中相同的
  private clickAccount(e: any) {
    this.currentSelection = this.productAccountList.filter((item: any) => {
      if (e.indexOf(item.id) !== -1) {
        if (!item.weight) {
          item.weight = {
            id: item.id,
            weight: ''
          }
        }
        return item
      }
    })
    // console.log(this.currentSelection, 'klkk')
  }

  // 产品账户列表的重复ID优化
  @Watch('infoForm.product_account')
  private onProductAccount(e: any) {
    return Array.from(new Set(this.productAccountList))
  }

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  // 监听当前创建的产品
  @Watch('product.name', { immediate: true })
  private productChange() {
    this.infoForm.product_name = this.product.name
    this.infoForm.product = this.product.id
    this.infoForm.status = this.product.status
    this.infoForm.product_account = []
    this.page = 1
    this.isLoad = true
    this.productAccountList = []
  }

  // 获取产品账户列表
  private async getAccountList() {
    if (!this.isLoad) {
      return false
    } else {
      const data: any = {
        product: this.infoForm.product,
        type: this.type
      }
      await newProductAccount(data).then((res: any) => {
        const list: any[] = res
        this.productAccountList = res
        if (list.length !== 0) {
          this.productAccountList.push.apply(this.productAccountList, list)
          this.productAccountList = [...new Set(this.productAccountList)]
          this.currentSelection = this.productAccountList.filter(
            (item: any) => {
              if (this.infoForm.product_account.indexOf(item.id) > -1) {
                return item
              }
            }
          )

          if (list.length < 50) {
            this.isLoad = false
          } else {
            this.page++
          }
        }
      })
    }
  }

  private back() {
    this.$emit('close')
  }

  private save() {
    ;(this.$refs.infoForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          // 处理产品账户选择之后的轮询权重数组
          this.reqArr = this.currentSelection.map((item: any) => {
            return {
              id: item.weight.id,
              weight: Number(item.weight.weight)
            }
          })
          this.loading = true
          this.flag = true
          const data: any = {
            ...this.infoForm,
            status: this.status,
            weight: this.reqArr
          }
          delObjEmptyKey(data)

          await addAccountGroup(data).then(() => {
            this.$message({
              message: 'Create Successful!',
              type: 'success'
            })
            this.loading = false
            this.flagStr()
            this.back()
          })
        } catch (e) {
          this.loading = false
          this.flagStr()
        }
      } else {
        return false
      }
    })
  }

  private type: string = 'normal'
  private selProductType() {
    if (this.type === 'ant') {
      this.productAccountList = []
      this.infoForm.product_account = []
      this.currentSelection = []
      this.arr = []
    } else {
      this.isLoad = true
      this.getAccountList()
    }
    // if (this.type === 'normal') {
    //   this.isLoad = true
    //   this.infoForm.product_account = []
    //   await this.getAccountList()
    // }
    // this.currentSelection = []
  }

  // 获取产品账户数组中相同的
  private clickAntAccount(e: any) {
    this.currentSelection = this.productAccountList.filter((item: any) => {
      if (e.indexOf(item.id) !== -1) {
        return item
      }
    })
  }
  private arr: any = []
  private antAccountList: any = []
  private async remoteMethod(query) {
    if (query !== '') {
      const data: any = {
        product: this.infoForm.product,
        name: query,
        type: this.type
      }
      await getProductAccountList(data).then((res: any) => {
        this.antAccountList = res.results
        this.antAccountList.forEach(item => {
          this.productAccountList.forEach(el => {
            if (item.id === el.id) {
              item.ant_state = 0
            }
          })
        })
      })
    }
  }
  private changeArr(val) {
    let indexLen: number = val.length
    val.forEach((item, index, arr) => {
      let itemArr: any = item.split(',')
      let obj: any = {}
      obj.id = itemArr[0] - 0
      obj.account_name = itemArr[1]
      obj.state = itemArr[2] - 0
      obj.weight = {
        weight: itemArr[3] - 0,
        id: itemArr[0] - 0
      }
      obj.account_type = itemArr[4]
      if (indexLen - 1 === index) {
        this.productAccountList.push(obj)
      }
    })
    const map = new Map()
    this.productAccountList = this.productAccountList.filter(
      v => !map.has(v.id) && map.set(v.id, 1)
    )
  }
  private itemArr: any = []
  private removeArr(val) {
    this.itemArr = val.split(',')
    this.productAccountList = this.productAccountList.filter(item => {
      return item.id !== this.itemArr[0] - 0
    })
  }

  private changeInput() {
    this.$forceUpdate()
  }

  private sysType: any = ''
  mounted() {
    this.sysType = getType()
    if (this.sysType === 'payment') {
      this.getAccountList()
    } else if (this.sysType === 'ant' && this.type === 'normal') {
      this.getAccountList()
    }
  }
}
